export enum ListFilterKeys {
  FilterRows = "filterRows",
  SelectAllRows = "filterRowsSelectAll",
  UnselectAllRows = "filterRowsUnselectAll",
  Enable = "displaySelectColumn",
  Disable = "hideSelectColumn",
}
